export default __webpack_public_path__ + "static/media/H0003.e3325679.png";